module.exports = __webpack_public_path__ + "static/img/question_icon.a1dbdcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question_icon.png
// module id = PMae
// module chunks = 1